import Axios from "axios"

export const postProductRegistration = (data) => {
  return Axios.post<{
    success: boolean
    message?: string
  }>(`/.netlify/functions/productRegistration`, data)
}
